import { computed, onMounted } from 'vue'
import useGet from '@/core/composables/api/useGet'
import type { LessonImpulseSummary } from '../models/lesson-impulse'

export const useLessonImpulses = () => {
  const { data, status, load, reload } =
    useGet<ReadonlyArray<LessonImpulseSummary>>('lesson-impulse')

  onMounted(() => {
    load()
  })

  const bookmarkedImpulses = computed(() => data.value?.filter((impulse) => impulse.bookmarkedAt))

  const runningImpulse = computed(() =>
    data.value?.find((impulse) => impulse.myLessonCounts.running > 0),
  )

  return {
    impulses: data,
    status,
    reload,
    bookmarkedImpulses,
    runningImpulse,
  }
}
